import { ButtonLink } from "../components/button-link";
import { SiteHeader } from "../components/site-header";

interface UnavailablePageProps {
  description: string;
  eyebrow: string;
  title: string;
}

export function UnavailablePage({ description, eyebrow, title }: UnavailablePageProps) {
  return (
    <div className="page-frame page-frame--soft">
      <a className="skip-link" href="#main-content">
        Skip to main content
      </a>
      <SiteHeader />
      <main id="main-content" className="state-page">
        <section className="state-card state-card--wide">
          <span className="lock-mark" aria-hidden="true">
            ·
          </span>
          <p className="eyebrow">{eyebrow}</p>
          <h1>{title}</h1>
          <p>{description}</p>
          <div className="state-card__actions">
            <ButtonLink to="/">Return home</ButtonLink>
          </div>
        </section>
      </main>
    </div>
  );
}
